import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from './message.service';
import { CookieService } from 'ngx-cookie-service';
import decode from 'jwt-decode';
declare var swal: any;

@Injectable({
	providedIn: 'root',
})
export class AuthService {
	token = '';
	token_data = null;
	ssoLoginURL: any = '';

	constructor(public message: MessageService, public cookieService: CookieService, public router: Router) {
		const stored_token = localStorage.getItem('token');
		if (stored_token) {
			this.token = stored_token;
			this.token_data = JSON.parse(decode(stored_token).sub);
		}
	}

	checkLogin() {
		const token = localStorage.getItem('token');
		if (token === null || token === undefined || token === '') {
			return false;
		} else {
			const tokenPayload = JSON.parse(decode(token).sub);
			const login_time = tokenPayload.logintime + 86315442;
			const current_time = new Date().getTime();
			return current_time <= login_time;
		}
	}

	logout() {
		swal({
			title: 'Logout',
			text: 'Are you sure?',
			type: 'question',
			showCancelButton: true,
			allowOutsideClick: false,
			backdrop: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: 'Yes',
			cancelButtonText: 'No',
		}).then(result => {
			if (result.value) {
				this.token = null;
				localStorage.clear();
				this.cookieService.deleteAll();
				window.location.href = this.ssoLoginURL;
				this.message.displaySnackbar('Logged Out Successfully!');
			}
		});
	}

	sessionExpired() {
		this.token = null;
		localStorage.clear();
		this.cookieService.deleteAll();
		window.location.href = this.ssoLoginURL;
		this.message.displaySnackbar('Session expired!');
	}

	unauthorizedAccess() {
		this.token = null;
		localStorage.clear();
		this.cookieService.deleteAll();
		window.location.href = this.ssoLoginURL;
		this.message.displaySnackbar('Unauthorized Access!');
	}
}
